// extracted by mini-css-extract-plugin
export default {"body":"login_body__X7bAn","form":"login_form__r5NSv","title":"login_title__1Dfmf"};